export const CLIENT_NODE_BACKGROUND_SYNC_CHANNEL = "client-node-background-sync";
export const CLIENT_NODE_BACKGROUND_SYNC_TAG = "node-client-sync";
export function createBackgroundSyncSignal(options = {}) {
    const channel = createChannel(options);
    const tag = options.tag ?? CLIENT_NODE_BACKGROUND_SYNC_TAG;
    return {
        close: () => channel.close(),
        request: () => channel.postMessage({ tag, type: "client-node.background-sync.requested" }),
    };
}
export function listenForBackgroundSyncRequests(listener, options = {}) {
    const channel = createChannel(options);
    const expectedTag = options.tag ?? CLIENT_NODE_BACKGROUND_SYNC_TAG;
    const onMessage = (event) => {
        if (!isBackgroundSyncRequest(event.data, expectedTag))
            return;
        listener(expectedTag);
    };
    channel.addEventListener("message", onMessage);
    return () => channel.close();
}
function createChannel(options) {
    if (options.createChannel !== undefined)
        return options.createChannel(options.channelName ?? CLIENT_NODE_BACKGROUND_SYNC_CHANNEL);
    if (typeof globalThis.BroadcastChannel !== "function")
        return new NoopBackgroundSyncChannel();
    return new globalThis.BroadcastChannel(options.channelName ?? CLIENT_NODE_BACKGROUND_SYNC_CHANNEL);
}
function isBackgroundSyncRequest(value, expectedTag) {
    if (typeof value !== "object" || value === null || Array.isArray(value))
        return false;
    const record = value;
    return record.tag === expectedTag && record.type === "client-node.background-sync.requested";
}
class NoopBackgroundSyncChannel {
    addEventListener() { }
    close() { }
    postMessage() { }
}
//# sourceMappingURL=background-sync.js.map